import { apiInstance } from "@src/config/api";
import { PUBLIC_V1 } from "@src/constant/common";
import { objectToQueryParams } from "@src/helper/objectToQueryParams";

const api = apiInstance()

export const getShareListing = async (slug) => {
  return api.get(`/${PUBLIC_V1}/property-shares/${slug}`)
}

export const getSimilarListing = async (slug, params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/module/portal/properties/${slug}/recommendations${newParams ? `?${newParams}` : ""}`)
}

export const getSimilarListingForOffice = async (slug, params = {}) => {
  const newParams = (!!params && typeof params === "object") ? `${objectToQueryParams(params)}` : ""
  return api.get(`/${PUBLIC_V1}/module/portal/properties/${slug}/office-recommendations${newParams ? `?${newParams}` : ""}`)
}

export const calculateKPR = async ({ params, slug }) => {
  return api.post(`/${PUBLIC_V1}/module/portal/properties/${slug}/simulation-kpr`, params)
}